import { SVGProps, Ref, forwardRef } from 'react';

export const SendAndroidFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="m11.955 5.288-6.833-3.37C2.675.713 1.452.11.804.777c-.647.668-.193 2.065.714 4.86l.172.532 8.058 1.831-8.057 1.832-.173.532C.61 13.16.158 14.556.804 15.223s1.87.065 4.318-1.142l6.833-3.369C14.318 9.547 15.5 8.964 15.5 8s-1.182-1.547-3.545-2.712"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SendAndroidFilledSize16Glyph.displayName = 'SendAndroidFilledSize16Glyph';
